<script setup>
import {onMounted, ref} from 'vue';

defineProps({
  modelValue: null,
});

defineEmits(['update:modelValue']);

const input = ref(null);

onMounted(() => {
  if (input.value.hasAttribute('autofocus')) {
    input.value.focus();
  }
});

defineExpose({focus: () => input.value.focus()});

const updateModelValue = (value) => {
  return Math.round(value);
}

const validateInput = (event) => {
  if ([37, 39, 8, 46, 9, 16, 17, 18].includes(event.keyCode)) {
    return true;
  }
  const pattern = /^[0-9]+$/
  if (!event.key.match(pattern)) {
    event.preventDefault();
    return false;
  }
}
</script>

<template>
  <input ref="input"
         type="number"
         class="shadow-sm border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 disabled:bg-white disabled:border-gray-200 disabled:text-gray-500"
         :value="modelValue"
         @keydown="validateInput"
         @input="$emit('update:modelValue', $event.target.value || 0)"
  >
</template>
